/**
 * As faixas de status: o que o editor le e grava.
 *
 * Mora com o COMPONENTE, e nao em `domain`, porque quem as conhece e ele - "Meus
 * Dados" e o detalhe do colaborador apenas o hospedam, e o que passam e o alvo.
 */
/** O caminho do endpoint de cada nivel. */
export function bandPathOf(target) {
    if (typeof target === 'string') {
        return target;
    }
    return 'patientId' in target ? 'patients' : 'companies';
}
/** Se o alvo e uma empresa - a forma que carrega `companyId`. */
export function isCompanyTarget(target) {
    return typeof target !== 'string' && 'companyId' in target;
}
//# sourceMappingURL=status-bands.types.js.map